import { jsxs as s, Fragment as y, jsx as p } from "react/jsx-runtime";
import { useMemo as C, useCallback as l } from "react";
import { S as P } from "../../StepParamInput.component-BhWeSFHZ.js";
import { StepParamsNewFieldInput as D } from "./StepParamsNewFieldInput.component.js";
import { o as A } from "../../omit-BQ2BPUFJ.js";
const N = ({
  state: o,
  dispatch: r,
  stepHandler: i,
  copies: m
}) => {
  const f = C(
    () => i.getFields(o.params),
    [i, o.params]
  ), u = l(
    (a, g) => {
      r({
        type: "PARAMS_UPDATED",
        payload: i.getUpdatedState(o.params, a, g)
      });
    },
    [r, o.params, i]
  ), F = l(
    (a, g) => {
      const e = i.getFieldValue(o.params, a), n = i.getFieldLogicLanguage(
        o,
        a
      );
      r({
        type: "PARAMS_CONFIG_UPDATED",
        payload: i.getUpdatedParamsConfigState(
          o.paramsConfig ?? {},
          o.params,
          a,
          {
            type: "logic",
            language: g
          }
        )
      }), r({
        type: "PARAMS_UPDATED",
        payload: i.getUpdatedState(
          o.params,
          a,
          n === "json-logic" && typeof e == "object" && g !== "json-logic" ? JSON.stringify(e) : e
        )
      });
    },
    [r, o, i]
  ), c = l(
    (a) => {
      const g = Array.isArray(o.params.__fieldsConfig) ? o.params.__fieldsConfig : [];
      r({
        type: "PARAMS_UPDATED",
        payload: {
          ...o.params,
          __fieldsConfig: [...g, a]
        }
      });
    },
    [r, o.params]
  ), _ = l(
    (a) => {
      const e = (Array.isArray(o.params.__fieldsConfig) ? o.params.__fieldsConfig : []).filter(
        (n) => n !== a
      );
      r({
        type: "PARAMS_UPDATED",
        payload: {
          ...A(o.params, a),
          __fieldsConfig: e
        }
      }), r({
        type: "PARAMS_CONFIG_UPDATED",
        payload: A(o.paramsConfig ?? {}, a)
      });
    },
    [r, o.params, o.paramsConfig]
  ), d = !!("allowAdditionalFields" in i && i.allowAdditionalFields);
  return /* @__PURE__ */ s(y, { children: [
    f.map((a) => {
      var g;
      return /* @__PURE__ */ p(
        P,
        {
          field: a,
          value: i.getFieldValue(o.params, a.fieldName),
          logicLanguage: i.getFieldLogicLanguage(
            o,
            a.fieldName
          ),
          logicLanguageOptions: i.getFieldLogicLanguageOptions(
            o,
            a.fieldName
          ),
          onLogicLanguageChange: F,
          onChange: u,
          error: ((g = o.paramErrors) == null ? void 0 : g[a.fieldName]) ?? "",
          copies: m,
          enableDeleteField: d,
          onDeleteField: _
        },
        a.fieldName
      );
    }),
    d && /* @__PURE__ */ p(D, { onAddField: c, copies: m })
  ] });
};
export {
  N as StepParamsFields
};
